import { render, staticRenderFns } from "./MypageTicketBlockSection.vue?vue&type=template&id=3881095c&scoped=true"
import script from "./MypageTicketBlockSection.vue?vue&type=script&lang=ts"
export * from "./MypageTicketBlockSection.vue?vue&type=script&lang=ts"
import style0 from "./MypageTicketBlockSection.vue?vue&type=style&index=0&id=3881095c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3881095c",
  null
  
)

export default component.exports